import axios from "axios";

// const baseUrl = 'http://localhost'
const baseUrl = "https://mais-conteudo-backend.somalabs.com.br";


export const getApi = (param: string) => {
  return `${baseUrl}${param}`
}

export default axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
  },
  transformRequest: [
    (data, headers: any) => {
      const token = localStorage.getItem("userToken");

      if (token) headers.common.Authorization = `Bearer ${token}`;

      return JSON.stringify(data);
    },
  ],
});
